import { render, staticRenderFns } from "./AtividadesEditarTrabalho.vue?vue&type=template&id=4a4441c1"
import script from "./AtividadesEditarTrabalho.vue?vue&type=script&lang=js"
export * from "./AtividadesEditarTrabalho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports